<template>
    <transition name="fade-in-up">
        <router-view></router-view>
    </transition>
</template>

<script>
export default {
    name: "CustomerCrmIndex"
}
</script>

<style scoped>

</style>